import { render, staticRenderFns } from "./fundsDetail.vue?vue&type=template&id=14ec18a3&scoped=true"
import script from "./fundsDetail.vue?vue&type=script&lang=js"
export * from "./fundsDetail.vue?vue&type=script&lang=js"
import style0 from "./fundsDetail.vue?vue&type=style&index=0&id=14ec18a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ec18a3",
  null
  
)

export default component.exports